import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'prodgeneratorPartial';

const fpProdgeneratorService = {
  getOrders: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orders`,
      data,
    });
  },

  getDetails: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/details/prodAndWarehouse`,
      data,
    });
  },

  getsourcelistByItemCode: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/sourcelistByItemCode`,
      data,
    });
  },

  createProduction: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/createProduction`,
      data,
    });
  },

  getAllSourceDataByItemCodes: (itemCodes) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/allSourceDataByItemCodes`,
      data: { itemCodes },
    });
  },

  createFromWarehouse: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/createFromWarehouse`,
      data,
    });
  },

  deleteFromWarhouse: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  markAsPrepared: (docId, lineNum) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/markAsPrepared/${encodeURIComponent(docId)}/${encodeURIComponent(lineNum)}`,
    });
  },

  updateOrderLine: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default fpProdgeneratorService;
